import * as C from "../constants";

import { get_organizations, put_organization, post_organization, delete_organization } from "utils/http";
import { parseJSON } from "utils/misc";
import { logout } from "./auth";
import { history } from "../history";

export function getOrganizationsRequest() {
    return {
        type: C.GET_ORGANIZATIONS_REQUEST,
    }
}

export function getOrganizationsFailure() {
    return {
        type: C.GET_ORGANIZATIONS_FAILURE,
    }
}

export function getOrganizationsSuccess(data) {
    return {
        type: C.GET_ORGANIZATIONS_SUCCESS,
        payload: data
    }
}

export function createOrganizationSuccess(data) {
    return {
        type: C.CREATE_ORGANIZATION,
        payload: data,
    }
}

export function createOrganizationFailure() {
    return {
        type: C.CREATE_ORGANIZATION_FAILURE,
    }
}

export function editOrganizationSuccess(data) {
    return {
        type: C.EDIT_ORGANIZATION,
        payload: data
    }
}

export function editOrganizationFailure() {
    return {
        type: C.EDIT_ORGANIZATION_FAILURE
    }
}

export function deleteOrganizationSuccess(data) {
    return {
        type: C.DELETE_ORGANIZATION,
        payload: data,
    }
}

export function deleteOrganizationFailure() {
    return {
        type: C.DELETE_ORGANIZATION_FAILURE
    }
}

export function getOrganizations(token) {
    return function (dispatch) {
        dispatch(getOrganizationsRequest());
        return get_organizations(token)
            .then(parseJSON).then(response => {
                dispatch(getOrganizationsSuccess(response))
        }).catch(error => {
            dispatch(getOrganizationsFailure());
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                history.replace("/login");
            }
        })
    }
}

export function createOrganization(token, organization) {
    return function (dispatch) {
        return post_organization(token, organization)
            .then(parseJSON).then(response => {
                dispatch(createOrganizationSuccess(response));
                return response
        }).catch(error => {
            dispatch(createOrganizationFailure());
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                history.replace("/login");
            }
        })
    }
}

export function editOrganization(token, organization) {
    return function (dispatch) {
        return put_organization(token, organization)
            .then(parseJSON).then(response => {
                dispatch(editOrganizationSuccess(response));
                return response;
        }).catch(error => {
            dispatch(editOrganizationFailure());
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                history.replace("/login");
            }
        })
    }
}

export function deleteOrganization(token, organization_id) {
    return function (dispatch) {
        return delete_organization(token, organization_id)
            .then(response => {
                dispatch(deleteOrganizationSuccess(organization_id))
                return response
            }).catch(error => {
            dispatch(deleteOrganizationFailure());
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                history.replace("/login");
            }
        })
    }
}


// WEBPACK FOOTER //
// ./src/actions/organizations.js